module.exports = __webpack_public_path__ + "static/media/7-team4.383c3b5b.jpg";